"use strict";

// =====================================================
// ISR
//
// Archivo:
// src/fronend/Egresos/isr/isr.js
//
// =====================================================

// =====================================================
// VARIABLES
// =====================================================

let registrosisr = [];

let moduloISRInicializado = false;

let empleadoSeleccionadoISR = null;

let cargandoISR = false;

let guardandoISR = false;

// =====================================================
// INICIALIZAR MODULO ISR
// =====================================================

function inicializarISR() {


if (moduloISRInicializado) {
    return;
}

moduloISRInicializado = true;

console.log(
    "Inicializando módulo ISR..."
);

cargarISR();

}

// =====================================================
// CARGAR ISR
// =====================================================

async function cargarISR() {


if (cargandoISR) {
    return;
}

cargandoISR = true;

try {

    const respuesta =
        await fetch(
            "/isr/listar"
        );


    const resultado =
        await respuesta.json();


    if (!respuesta.ok) {

        throw new Error(
            resultado.mensaje ||
            "Error al consultar ISR."
        );

    }


    if (!resultado.ok) {

        throw new Error(
            resultado.mensaje ||
            "No fue posible cargar los registros de ISR."
        );

    }


    registrosisr =
        Array.isArray(
            resultado.data
        )
            ? resultado.data
            : [];


    console.log(
        "===================================="
    );

    console.log(
        "REGISTROS ISR CARGADOS"
    );

    console.log(
        registrosisr
    );

    console.log(
        "===================================="
    );


    renderizarTablaISR();

    actualizarResumenISR();


} catch (error) {

    console.error(
        "Error al cargar ISR:",
        error
    );

    registrosisr = [];

    renderizarTablaISR();

    actualizarResumenISR();


} finally {

    cargandoISR = false;

}


}

// =====================================================
// RENDERIZAR TABLA ISR
// =====================================================

function renderizarTablaISR() {


const tbody =
    document.getElementById(
        "tbodyISR"
    );


if (!tbody) {

    console.warn(
        "No se encontró #tbodyISR"
    );

    return;

}


tbody.innerHTML = "";


if (
    !Array.isArray(
        registrosisr
    ) ||
    registrosisr.length === 0
) {

    tbody.innerHTML = `

        <tr>

            <td
                colspan="15"
                class="text-center text-muted py-4">

                No hay registros de ISR disponibles.

            </td>

        </tr>

    `;

    return;

}


registrosisr.forEach(
    (
        registro,
        index
    ) => {

        const fila =
            document.createElement(
                "tr"
            );


        fila.innerHTML = `

            <td>
                ${index + 1}
            </td>

            <td>
                ${escaparHTML(
                    registro.IDEGRESOS
                )}
            </td>

            <td>
                ${formatearFechaISR(
                    registro.FECHA
                )}
            </td>

            <td>
                ${escaparHTML(
                    registro.NOMBREEMPLEADO
                )}
            </td>

            <td>
                ${escaparHTML(
                    registro.DPI
                )}
            </td>

            <td>
                ${escaparHTML(
                    registro.NOMBREPUESTO
                )}
            </td>

            <td>
                ${escaparHTML(
                    registro.DIRECCION
                )}
            </td>

            <td class="text-end">

                ${formatearMonedaISR(
                    registro.SALARIOBASE
                )}

            </td>

            <td>

                ${formatearFechaISR(
                    registro.FECHAREGISTRO
                )}

            </td>

            <td class="text-end">

                ${formatearNumeroISR(
                    obtenerIGSSISR(
                        registro
                    )
                )}

            </td>

            <td class="text-end">

                ${formatearMonedaISR(
                    obtenerPagarIGSSISR(
                        registro
                    )
                )}

            </td>

            <td class="text-end">

                ${formatearNumeroISR(
                    registro.ISR
                )}

            </td>

            <td class="text-end">

                ${formatearMonedaISR(
                    registro.PAGARISR
                )}

            </td>

            <td class="text-center">

                ${
                    registro.ESTADO === "A"

                        ? `

                            <span
                                class="badge bg-success">

                                ACTIVO

                            </span>

                          `

                        : `

                            <span
                                class="badge bg-secondary">

                                INACTIVO

                            </span>

                          `
                }

            </td>

            <td class="text-center">

                ${
                    registro.ESTADO === "A"

                        ? `

                            <button
                                type="button"
                                class="btn btn-success btn-sm"
                                title="Pagar ISR"
                                onclick="pagarISR(${registro.IDEGRESOS})">

                                <i
                                    class="bi bi-cash-coin me-1">
                                </i>

                                PAGAR ISR

                            </button>

                          `

                        : `

                            <button
                                type="button"
                                class="btn btn-secondary btn-sm"
                                disabled
                                title="Registro inactivo">

                                <i
                                    class="bi bi-lock me-1">
                                </i>

                                PAGAR ISR

                            </button>

                          `
                }

            </td>

        `;


        tbody.appendChild(
            fila
        );

    }
);


}

// =====================================================
// OBTENER IGSS
// =====================================================

function obtenerIGSSISR(
registro
) {


const valor =
    registro.IGSS ??
    registro.PORCENTAJEIGSS ??
    registro.PORCENTAJE_IGSS ??
    registro.VALORIGSS ??
    registro.TASAIGSS ??
    0;


return convertirNumeroISR(
    valor
);


}

// =====================================================
// OBTENER PAGO IGSS
// =====================================================

function obtenerPagarIGSSISR(
registro
) {


const valor =
    registro.PAGARIGSS ??
    registro.PAGOIGSS ??
    registro.PAGAR_IGSS ??
    registro.IGSSPAGAR ??
    0;


return convertirNumeroISR(
    valor
);


}

// =====================================================
// PAGAR ISR
// =====================================================

function pagarISR(
idEgresos
) {

if (!idEgresos) {

    console.error(
        "No se recibió el IDEGRESOS."
    );

    alert(
        "No se recibió el ID del egreso."
    );

    return;

}


const registro =
    registrosisr.find(
        item =>
            Number(
                item.IDEGRESOS
            ) ===
            Number(
                idEgresos
            )
    );


if (!registro) {

    console.error(
        "No se encontró el registro ISR:",
        idEgresos
    );

    alert(
        "No se encontró la información del registro seleccionado."
    );

    return;

}


empleadoSeleccionadoISR =
    registro;


console.log(
    "===================================="
);

console.log(
    "REGISTRO ISR SELECCIONADO"
);

console.log(
    registro
);

console.log(
    "IGSS:",
    obtenerIGSSISR(
        registro
    )
);

console.log(
    "PAGAR IGSS:",
    obtenerPagarIGSSISR(
        registro
    )
);

console.log(
    "===================================="
);


cargarDatosModalISR(
    registro
);


const elementoModal =
    document.getElementById(
        "modalISR"
    );


if (!elementoModal) {

    console.error(
        "No se encontró #modalISR"
    );

    alert(
        "No se encontró el modal para pagar ISR."
    );

    return;

}


if (
    typeof bootstrap ===
    "undefined"
) {

    console.error(
        "Bootstrap no está cargado."
    );

    alert(
        "Bootstrap no está cargado correctamente."
    );

    return;

}


const modal =
    bootstrap.Modal.getOrCreateInstance(
        elementoModal
    );


modal.show();


}

// =====================================================
// CARGAR DATOS EN MODAL ISR
// =====================================================

function cargarDatosModalISR(
registro
) {


console.log(
    "===================================="
);

console.log(
    "CARGANDO DATOS AL MODAL ISR"
);

console.log(
    "Registro recibido:",
    registro
);

console.log(
    "===================================="
);


const valorIGSS =
    obtenerIGSSISR(
        registro
    );


const pagoIGSS =
    obtenerPagarIGSSISR(
        registro
    );


const salario =
    convertirNumeroISR(
        registro.SALARIOBASE
    );


const valorISR =
    convertirNumeroISR(
        registro.ISR
    );


console.log(
    "SALARIO BASE:",
    salario
);

console.log(
    "IGSS:",
    valorIGSS
);

console.log(
    "PAGAR IGSS:",
    pagoIGSS
);

console.log(
    "ISR:",
    valorISR
);


// =================================================
// IDEGRESOS
// =================================================

const idEgresos =
    document.getElementById(
        "idEgresos"
    );


if (idEgresos) {

    idEgresos.value =
        registro.IDEGRESOS ?? "";

}


// =================================================
// FECHA EGRESO
// =================================================

const fechaEgreso =
    document.getElementById(
        "fechaEgreso"
    );


if (fechaEgreso) {

    fechaEgreso.value =
        convertirFechaInputISR(
            registro.FECHA
        );

}


// =================================================
// ESTADO
// =================================================

const estadoISR =
    document.getElementById(
        "estadoISR"
    );


if (estadoISR) {

    estadoISR.value =
        registro.ESTADO ?? "A";

}


// =================================================
// NOMBRE
// =================================================

const nombreEmpleado =
    document.getElementById(
        "nombreEmpleado"
    );


if (nombreEmpleado) {

    nombreEmpleado.value =
        registro.NOMBREEMPLEADO ?? "";

}


// =================================================
// DPI
// =================================================

const dpiEmpleado =
    document.getElementById(
        "dpiEmpleado"
    );


if (dpiEmpleado) {

    dpiEmpleado.value =
        registro.DPI ?? "";

}


// =================================================
// PUESTO
// =================================================

const puestoEmpleado =
    document.getElementById(
        "puestoEmpleado"
    );


if (puestoEmpleado) {

    puestoEmpleado.value =
        registro.NOMBREPUESTO ?? "";

}


// =================================================
// DIRECCION
// =================================================

const direccionEmpleado =
    document.getElementById(
        "direccionEmpleado"
    );


if (direccionEmpleado) {

    direccionEmpleado.value =
        registro.DIRECCION ?? "";

}


// =================================================
// SALARIO BASE
// =================================================

const salarioBase =
    document.getElementById(
        "salarioBase"
    );


if (salarioBase) {

    salarioBase.value =
        salario.toFixed(2);

}


// =================================================
// FECHA REGISTRO
// =================================================

const fechaRegistro =
    document.getElementById(
        "fechaRegistro"
    );


if (fechaRegistro) {

    fechaRegistro.value =
        convertirFechaInputISR(
            registro.FECHAREGISTRO
        );

}


// =================================================
// IGSS
// =================================================

const igss =
    document.getElementById(
        "igss"
    );


if (igss) {

    igss.value =
        valorIGSS.toFixed(2);

}


// =================================================
// PORCENTAJE IGSS
// =================================================

const porcentajeIGSS =
    document.getElementById(
        "porcentajeIGSS"
    );


if (porcentajeIGSS) {

    porcentajeIGSS.value =
        valorIGSS.toFixed(2);

}


// =================================================
// VALOR IGSS
// =================================================

const valorIGSSInput =
    document.getElementById(
        "valorIGSS"
    );


if (valorIGSSInput) {

    valorIGSSInput.value =
        valorIGSS.toFixed(2);

}


// =================================================
// PAGAR IGSS
// =================================================

const pagarIGSS =
    document.getElementById(
        "pagarIGSS"
    );


if (pagarIGSS) {

    pagarIGSS.value =
        pagoIGSS.toFixed(2);

}


// =================================================
// PAGO IGSS
// =================================================

const pagoIGSSInput =
    document.getElementById(
        "pagoIGSS"
    );


if (pagoIGSSInput) {

    pagoIGSSInput.value =
        pagoIGSS.toFixed(2);

}


// =================================================
// ISR
// =================================================

const isr =
    document.getElementById(
        "isr"
    );


if (isr) {

    isr.value =
        valorISR > 0
            ? valorISR.toFixed(2)
            : "";

}


// =================================================
// CALCULAR PAGO ISR
// =================================================

calcularPagoISR();


// =================================================
// ACTUALIZAR CALCULOS
// =================================================

actualizarCalculosISR();


}

// =====================================================
// CALCULAR PAGO ISR
//
// FORMULA:
//
// SALARIO BASE * PORCENTAJE ISR / 100
//
// =====================================================

function calcularPagoISR() {

const salarioBaseInput =
    document.getElementById(
        "salarioBase"
    );


const isrInput =
    document.getElementById(
        "isr"
    );


const pagarISRInput =
    document.getElementById(
        "pagarISR"
    );


if (
    !salarioBaseInput ||
    !isrInput ||
    !pagarISRInput
) {

    return;

}


const salario =
    convertirNumeroISR(
        salarioBaseInput.value
    );


const porcentajeISR =
    convertirNumeroISR(
        isrInput.value
    );


// =================================================
// CALCULO
// =================================================

const pagoISR =
    salario *
    porcentajeISR /
    100;


// =================================================
// MOSTRAR PAGO ISR
// =================================================

pagarISRInput.value =
    pagoISR.toFixed(2);


console.log(
    "===================================="
);

console.log(
    "CALCULO ISR"
);

console.log(
    "SALARIO BASE:",
    salario.toFixed(2)
);

console.log(
    "PORCENTAJE ISR:",
    porcentajeISR.toFixed(2) + "%"
);

console.log(
    "PAGO ISR:",
    pagoISR.toFixed(2)
);

console.log(
    "===================================="
);


actualizarCalculosISR();


}

// =====================================================
// GUARDAR / ACTUALIZAR ISR
//
// PUT:
// /isr/actualizar
//
// ENVIA:
//
// IDEGRESOS
// ISR
// PAGARISR
//
// =====================================================

async function guardarISR() {


if (guardandoISR) {

    return;

}


// =================================================
// OBTENER CAMPOS
// =================================================

const idEgresosInput =
    document.getElementById(
        "idEgresos"
    );


const isrInput =
    document.getElementById(
        "isr"
    );


const pagarISRInput =
    document.getElementById(
        "pagarISR"
    );


if (
    !idEgresosInput ||
    !isrInput ||
    !pagarISRInput
) {

    alert(
        "No se encontraron los campos necesarios para guardar el ISR."
    );

    return;

}


// =================================================
// OBTENER VALORES
// =================================================

const idEgresos =
    convertirNumeroISR(
        idEgresosInput.value
    );


const isr =
    convertirNumeroISR(
        isrInput.value
    );


const pagoISR =
    convertirNumeroISR(
        pagarISRInput.value
    );


// =================================================
// VALIDACIONES
// =================================================

if (
    idEgresos <= 0
) {

    alert(
        "El IDEGRESOS no es válido."
    );

    return;

}


if (
    isr < 0
) {

    alert(
        "El ISR no puede ser negativo."
    );

    return;

}


if (
    pagoISR < 0
) {

    alert(
        "El PAGOISR no puede ser negativo."
    );

    return;

}


// =================================================
// CONFIRMAR
// =================================================

const confirmar =
    confirm(
        "¿Desea guardar el pago de ISR para este empleado?"
    );


if (!confirmar) {

    return;

}


guardandoISR = true;


try {

    console.log(
        "===================================="
    );

    console.log(
        "GUARDANDO ISR"
    );

    console.log(
        "IDEGRESOS:",
        idEgresos
    );

    console.log(
        "ISR:",
        isr
    );

    console.log(
        "PAGARISR:",
        pagoISR
    );

    console.log(
        "===================================="
    );


    // =================================================
    // ENVIAR AL BACKEND
    // =================================================

    const respuesta =
        await fetch(
            "/isr/actualizar",
            {

                method: "PUT",

                headers: {

                    "Content-Type":
                        "application/json"

                },

                body:
                    JSON.stringify({

                        IDEGRESOS:
                            idEgresos,

                        ISR:
                            isr,

                        PAGOISR:
                            pagoISR

                    })

            }
        );


    // =================================================
    // LEER RESPUESTA
    // =================================================

    const resultado =
        await respuesta.json();


    // =================================================
    // VALIDAR RESPUESTA
    // =================================================

    if (!respuesta.ok) {

        throw new Error(
            resultado.mensaje ||
            "Error al actualizar el ISR."
        );

    }


    if (!resultado.ok) {

        throw new Error(
            resultado.mensaje ||
            "No fue posible actualizar el ISR."
        );

    }


    // =================================================
    // MENSAJE
    // =================================================

    alert(
        resultado.mensaje ||
        "ISR actualizado correctamente."
    );


    // =================================================
    // CERRAR MODAL
    // =================================================

    const elementoModal =
        document.getElementById(
            "modalISR"
        );


    if (elementoModal) {

        const modal =
            bootstrap.Modal.getInstance(
                elementoModal
            );


        if (modal) {

            modal.hide();

        }

    }


    // =================================================
    // LIMPIAR SELECCION
    // =================================================

    empleadoSeleccionadoISR =
        null;


    // =================================================
    // RECARGAR TABLA
    // =================================================

    await cargarISR();


} catch (error) {

    console.error(
        "Error al guardar ISR:",
        error
    );


    alert(
        error.message ||
        "Error al actualizar el ISR."
    );


} finally {

    guardandoISR = false;

}


}

// =====================================================
// ACTUALIZAR CALCULOS ISR
//
// Actualiza:
//
// - Sueldo después de IGSS
// - Resumen ISR
// - Total
//
// NO CALCULA SUELDO DESPUES DE ISR
// =====================================================

function actualizarCalculosISR() {


const salarioBaseInput =
    document.getElementById(
        "salarioBase"
    );


const pagarIGSSInput =
    document.getElementById(
        "pagarIGSS"
    );


const pagarISRInput =
    document.getElementById(
        "pagarISR"
    );


if (
    !salarioBaseInput ||
    !pagarISRInput
) {

    return;

}


const salario =
    convertirNumeroISR(
        salarioBaseInput.value
    );


const pagoIGSS =
    pagarIGSSInput
        ? convertirNumeroISR(
            pagarIGSSInput.value
        )
        : 0;


const pagoISR =
    convertirNumeroISR(
        pagarISRInput.value
    );


// =================================================
// SUELDO DESPUES DE IGSS
// =================================================

const sueldoDespuesIGSS =
    salario -
    pagoIGSS;


const sueldoDespuesIGSSInput =
    document.getElementById(
        "sueldoDespuesIGSS"
    );


if (sueldoDespuesIGSSInput) {

    sueldoDespuesIGSSInput.value =
        sueldoDespuesIGSS.toFixed(2);

}


// =================================================
// RESUMEN SALARIO
// =================================================

const resumenSalario =
    document.getElementById(
        "resumenSalario"
    );


if (resumenSalario) {

    resumenSalario.textContent =
        formatearMonedaISR(
            salario
        );

}


// =================================================
// RESUMEN IGSS
// =================================================

const resumenIGSS =
    document.getElementById(
        "resumenIGSS"
    );


if (resumenIGSS) {

    resumenIGSS.textContent =
        formatearMonedaISR(
            pagoIGSS
        );

}


// =================================================
// RESUMEN ISR
// =================================================

const resumenISR =
    document.getElementById(
        "resumenISR"
    );


if (resumenISR) {

    resumenISR.textContent =
        formatearMonedaISR(
            pagoISR
        );

}


// =================================================
// LABEL PAGAR ISR
// =================================================

const labelPagarISR =
    document.getElementById(
        "labelPagarISR"
    );


if (labelPagarISR) {

    labelPagarISR.textContent =
        formatearMonedaISR(
            pagoISR
        );

}


}

// =====================================================
// ACTUALIZAR RESUMEN ISR
// =====================================================

function actualizarResumenISR() {

let totalEmpleados = 0;

let totalSalarios = 0;

let totalIGSS = 0;

let totalISR = 0;


registrosisr.forEach(
    registro => {

        totalEmpleados++;


        totalSalarios +=
            convertirNumeroISR(
                registro.SALARIOBASE
            );


        totalIGSS +=
            obtenerPagarIGSSISR(
                registro
            );


        totalISR +=
            convertirNumeroISR(
                registro.PAGARISR
            );

    }
);


const totalEmpleadosElemento =
    document.getElementById(
        "totalEmpleados"
    );


if (totalEmpleadosElemento) {

    totalEmpleadosElemento.textContent =
        totalEmpleados;

}


const totalSalariosElemento =
    document.getElementById(
        "totalSalarios"
    );


if (totalSalariosElemento) {

    totalSalariosElemento.textContent =
        formatearMonedaISR(
            totalSalarios
        );

}


const totalIGSSElemento =
    document.getElementById(
        "totalIGSS"
    );


if (totalIGSSElemento) {

    totalIGSSElemento.textContent =
        formatearMonedaISR(
            totalIGSS
        );

}


const totalISRElemento =
    document.getElementById(
        "totalISR"
    );


if (totalISRElemento) {

    totalISRElemento.textContent =
        formatearMonedaISR(
            totalISR
        );

}


}

// =====================================================
// BUSCAR ISR
// =====================================================

function buscarISR() {


const input =
    document.getElementById(
        "buscarISR"
    );


const texto =
    input
        ? input.value
            .trim()
            .toLowerCase()
        : "";


const filas =
    document.querySelectorAll(
        "#tbodyISR tr"
    );


filas.forEach(
    fila => {

        const contenido =
            fila.textContent
                .toLowerCase();


        if (
            contenido.includes(
                texto
            )
        ) {

            fila.style.display =
                "";

        } else {

            fila.style.display =
                "none";

        }

    }
);


}

// =====================================================
// CONVERTIR NUMERO
// =====================================================

function convertirNumeroISR(
valor
) {


if (
    valor === null ||
    valor === undefined ||
    valor === ""
) {

    return 0;

}


if (
    typeof valor ===
    "number"
) {

    return Number.isFinite(
        valor
    )
        ? valor
        : 0;

}


let texto =
    String(
        valor
    ).trim();


texto =
    texto.replaceAll(
        ",",
        ""
    );


texto =
    texto.replace(
        /^Q\s*/i,
        ""
    );


texto =
    texto.replace(
        /%/g,
        ""
    );


const numero =
    Number(
        texto
    );


return Number.isFinite(
    numero
)
    ? numero
    : 0;


}

// =====================================================
// FORMATEAR NUMERO DECIMAL
// =====================================================

function formatearNumeroISR(
valor
) {


return convertirNumeroISR(
    valor
).toFixed(2);


}

// =====================================================
// FORMATEAR MONEDA
// =====================================================

function formatearMonedaISR(
valor
) {


return convertirNumeroISR(
    valor
).toLocaleString(
    "es-GT",
    {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }
);


}

// =====================================================
// FORMATEAR FECHA
// =====================================================

function formatearFechaISR(
fecha
) {


if (!fecha) {
    return "";
}


const fechaObjeto =
    new Date(
        fecha
    );


if (
    Number.isNaN(
        fechaObjeto.getTime()
    )
) {

    return fecha;

}


return fechaObjeto.toLocaleDateString(
    "es-GT",
    {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    }
);


}

// =====================================================
// CONVERTIR FECHA INPUT DATE
// =====================================================

function convertirFechaInputISR(
fecha
) {


if (!fecha) {
    return "";
}


if (
    typeof fecha === "string" &&
    /^\d{4}-\d{2}-\d{2}$/.test(
        fecha
    )
) {

    return fecha;

}


const fechaObjeto =
    new Date(
        fecha
    );


if (
    Number.isNaN(
        fechaObjeto.getTime()
    )
) {

    return "";

}


const año =
    fechaObjeto
        .getFullYear()
        .toString()
        .padStart(
            4,
            "0"
        );


const mes =
    (
        fechaObjeto.getMonth() + 1
    )
        .toString()
        .padStart(
            2,
            "0"
        );


const dia =
    fechaObjeto
        .getDate()
        .toString()
        .padStart(
            2,
            "0"
        );


return `${año}-${mes}-${dia}`;


}

// =====================================================
// ESCAPAR HTML
// =====================================================

function escaparHTML(
valor
) {


return String(
    valor ?? ""
)
    .replaceAll(
        "&",
        "&amp;"
    )
    .replaceAll(
        "<",
        "&lt;"
    )
    .replaceAll(
        ">",
        "&gt;"
    )
    .replaceAll(
        '"',
        "&quot;"
    )
    .replaceAll(
        "'",
        "&#039;"
    );


}

// =====================================================
// EVENTOS DEL MODULO ISR
// =====================================================

document.addEventListener(
"DOMContentLoaded",
() => {


    // =================================================
    // BUSCADOR
    // =================================================

    const buscar =
        document.getElementById(
            "buscarISR"
        );


    if (buscar) {

        buscar.addEventListener(
            "input",
            buscarISR
        );

    }


    // =================================================
    // INPUT ISR
    //
    // CADA VEZ QUE EL USUARIO ESCRIBA
    // SE RECALCULA EL PAGO
    // =================================================

    const isrInput =
        document.getElementById(
            "isr"
        );


    if (isrInput) {

        isrInput.addEventListener(
            "input",
            calcularPagoISR
        );

    }


    inicializarISR();

}


);

// =====================================================
// EXPORTAR
// =====================================================

window.inicializarISR =
inicializarISR;

window.cargarISR =
cargarISR;

window.buscarISR =
buscarISR;

window.pagarISR =
pagarISR;

window.guardarISR =
guardarISR;

window.cargarDatosModalISR =
cargarDatosModalISR;

window.actualizarResumenISR =
actualizarResumenISR;

window.calcularPagoISR =
calcularPagoISR;

window.actualizarCalculosISR =
actualizarCalculosISR;
